import { ReactNode } from 'react';

type ContentContainerProps = {
    children: ReactNode | ReactNode[];
};

function ContentContainer({ children }: ContentContainerProps): JSX.Element {
    return (
        <div className="py-4 h-full flex flex-col px-1">
            <div>{children}</div>
        </div>
    );
}

export default ContentContainer;
